import type { UnitConfiguration, PropertyUnit } from '@/lib/units';
import { HierarchicalConfigurationView } from './HierarchicalConfigurationView';
import { cn } from '@/lib/utils';

interface ConfigurationSummaryViewProps {
  configurations: UnitConfiguration[];
  units: PropertyUnit[];
  onConfigurationClick: (configuration: UnitConfiguration) => void;
  onUnitClick: (unit: PropertyUnit) => void;
  className?: string;
}

export const ConfigurationSummaryView = ({
  configurations,
  units,
  onConfigurationClick,
  onUnitClick,
  className,
}: ConfigurationSummaryViewProps) => {
  return (
    <HierarchicalConfigurationView
      configurations={configurations}
      units={units}
      onConfigurationClick={onConfigurationClick}
      onUnitClick={onUnitClick}
      className={className}
    />
  );
};

